import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dropdown, Space, Select, Tooltip } from 'antd';
import { DownOutlined, UserOutlined, TeamOutlined } from '@ant-design/icons';
import Password from "@/component/password";
import { STATIC_RESOURCE } from '@/utils/tools';
import { useI18n } from '@/i18n';
import { userSwitchCompanys } from '@/utils/api/common';
import { stopNoticePoller } from '@/utils/noticePoller';
import { resetNoticeState } from '@/app/reducers/noticeSlice';
import { asyncAppReload, resetAppInitialized } from '@/app/reducers/appReducer';
import { AUTH_PAGES } from '@/constants/paths';
import { storage } from '@/utils/storage';

export default function Index() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const $t = useI18n('component.header.language');
  const [passModal, setPassModal] = useState(false);

  const token = storage.get('token');
  const { username = '', company_id = '', level, is_system } = useSelector(state => state.lang.user_info) || {};
  const { company_name = '-' } = useSelector(state => state.lang.company_info) || {};
  const companyList = useSelector(state => state.company?.list || []);

  const switchCompanyItem = companyList?.length === 0 ? undefined : {
    key: '2', label: (<span>{$t('Switch company')}</span>), icon: <img src={`${STATIC_RESOURCE}/cp_gsp/header/exchange_account.png`} width={20} height={20} alt={``} />,
    children: [
      {
        key: '2-1',
        label: (
          <div onClick={e => e.stopPropagation()}>
            <Select
              filterOption={(input, option) => (option?.name ?? '').toLowerCase().includes(input.toLowerCase())}
              style={{ width: 260, margin: '10px auto', }}
              showSearch
              onSelect={(value) => handleOnSwitchCompany(value)}
              fieldNames={{ label: 'name', value: 'id' }}
              options={companyList}
              onKeyDown={(e) => {
                if (['Enter', 13].includes(e.key)) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }} />
          </div >
        )
      }
    ]
  };

  const items = [
    { key: '1', label: (<span>{$t('Company Management')}</span>), icon: <img src={`${STATIC_RESOURCE}/cp_gsp/header/company_manage.png`} width={20} height={20} alt={``} /> },
    switchCompanyItem,
    { key: '3', label: (<span>{$t('Change Password')}</span>), icon: <img src={`${STATIC_RESOURCE}/cp_gsp/header/modify_password.png`} width={20} height={20} alt={``} /> },
    { key: '4', label: (<span>{$t('Create/Associate Company')}</span>), icon: <img src={`${STATIC_RESOURCE}/cp_gsp/header/create_or_associate_company.png`} width={20} height={20} alt={``} /> },
    { key: '5', label: (<span>{$t('Log out')}</span>), icon: <img src={`${STATIC_RESOURCE}/cp_gsp/header/logout.png`} width={20} height={20} alt={``} /> },
  ].filter(item => item);

  const onDropdownClick = async ({ key }) => {
    if (key === '1') {
      navigate(company_id ? '/company/info' : '/apply');
    } else if (key === '3') {
      setPassModal(true);
    } else if (key === '4') {
      navigate('/apply');
    } else if (key === '5') {
      const { pathname, search } = location;
      stopNoticePoller();
      dispatch(resetNoticeState());
      storage.safeClear();
      navigate(`/login?redirect=${pathname}${search}`, { replace: true });
    }
  };

  const handleOnSwitchCompany = async (key) => {
    const { data: { data: { company_info, token, user_info }, code }, } = await userSwitchCompanys({ switch_company_id: key });
    if (+code === 0) {
      storage.set('company_info', company_info);
      storage.set('token', token);
      storage.set('user_info', user_info);
      storage.set('user_id', user_info.id);
      stopNoticePoller();
      dispatch(resetNoticeState());
      dispatch(resetAppInitialized());
      dispatch(asyncAppReload());
      navigate('/home', { replace: true });
    }
  };

  const closePassModal = () => {
    setPassModal(false);
  };

  if (!token) return null;

  return (
    <>
      {!AUTH_PAGES.includes(location.pathname) && (
        <Dropdown menu={{ items, onClick: onDropdownClick }} destroyOnHidden trigger={['hover']}>
          <Space>
            <span className='header-left_title'>
              <div>
                <Tooltip title={company_name}>{company_name}</Tooltip>
              </div>
              <div>
                <Tooltip title={$t('Administrators')}>{+level === 2 ? <UserOutlined style={{ color: '#d60505' }} /> : ''}</Tooltip>
                <Tooltip title={$t('Agency Operations')}>{+is_system === 1 ? <TeamOutlined style={{ color: '#d60505' }} /> : ''}</Tooltip>
                <Tooltip title={username}>{username.slice(0, 10)}</Tooltip>
              </div>
            </span>
            <DownOutlined />
          </Space>
        </Dropdown>
      )}
      {passModal ? (<Password closePassModal={closePassModal} />) : ""}
    </>
  );
}